import { render, staticRenderFns } from "./FlatCard.vue?vue&type=template&id=587172e8&scoped=true&"
import script from "./FlatCard.vue?vue&type=script&lang=js&"
export * from "./FlatCard.vue?vue&type=script&lang=js&"
import style0 from "./FlatCard.vue?vue&type=style&index=0&id=587172e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587172e8",
  null
  
)

export default component.exports